type Endpoints = {
  name: string;
  endpoint: string;
};

export type AmplifyConfigType = {
  aws_appsync_graphqlEndpoint: string;
  aws_appsync_region: string;
  API: {
    endpoints: [Endpoints];
  };
  restApiEndpoint: string;
};

type SimplifiedConfig = {
  appSyncGraphqlEndpoint: string;
  restApiEndpoint: string;
};

const expandConfig = (config: SimplifiedConfig): AmplifyConfigType => {
  return {
    aws_appsync_graphqlEndpoint: config.appSyncGraphqlEndpoint,
    aws_appsync_region: 'us-east-1',
    API: {
      endpoints: [
        {
          name: 'gql',
          endpoint: config.appSyncGraphqlEndpoint,
        },
      ],
    },
    restApiEndpoint: config.restApiEndpoint,
  };
};

const AmplifyConfigBranch: AmplifyConfigType = expandConfig({
  appSyncGraphqlEndpoint: 'http://localhost:8080/graphql',
  restApiEndpoint: 'http://localhost:8080',
});

const AmplifyConfigDev: AmplifyConfigType = expandConfig({
  appSyncGraphqlEndpoint: 'https://condor-api-dev.cs.dev.opetics.com/graphql',
  restApiEndpoint: 'https://condor-api-dev.cs.dev.opetics.com',
});

const AmplifyConfigStaging: AmplifyConfigType = expandConfig({
  appSyncGraphqlEndpoint:
    'https://condor-api-staging.cs.dev.opetics.com/graphql',
  restApiEndpoint: 'https://condor-api-staging.cs.dev.opetics.com',
});

const AmplifyConfigProd: AmplifyConfigType = expandConfig({
  appSyncGraphqlEndpoint: 'https://condor-api.cs.prod.opetics.com/graphql',
  restApiEndpoint: 'https://condor-api.cs.prod.opetics.com',
});

export {
  AmplifyConfigStaging,
  AmplifyConfigDev,
  AmplifyConfigBranch,
  AmplifyConfigProd,
};
